export { default } from './ButtonBase';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/ButtonBase/index.js
// module id = 15
// module chunks = 0